export default __webpack_public_path__ + "static/media/no-product.7a89d599.svg";